import React, {useEffect, useState} from 'react'
import "./PaymentModal.css"
import paymentVerifying from "../../../assets/images/verifying.png"
import paymentSuccess from "../../../assets/images/payment-successful.png"
import paymentFailed from "../../../assets/images/payment-failed.png"
import { useNavigate } from 'react-router-dom'

const PaymentModal = ({paymentModal, setPaymentModal}) => {
  const [paymentStatus, setPaymentStatus] = useState("pending")
  const navigate = useNavigate()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get("payment_status") 
    if (!paymentStatus ) return setPaymentStatus("disable")
    if (paymentStatus) setPaymentStatus("pending")
    if (paymentStatus === "Failed") {

      setTimeout(() => { 
        setPaymentStatus("failed")
      }, 2000)
      setTimeout(() => {
        setPaymentModal(false)
        navigate("/campaign")
        // window.location.reload()
      }, 4000)
    
    }else {
      setTimeout(() => { 
        setPaymentStatus("success")
      }, 2000)
      setTimeout(() => { 
        setPaymentStatus("campaignCreated")
      }, 3000)
      setTimeout(() => {
        setPaymentModal(false)
        navigate("/campaign")
        // window.location.reload()
      }, 6000)
   
    }

}, []);

  return (
    <div className='paymentModal scale-up-center'>
      {paymentStatus === "pending" &&  <img  src={paymentVerifying} />}
      {paymentStatus === "success" &&  <img  src={paymentSuccess} />}
      {paymentStatus === "failed" &&  <img  src={paymentFailed} />}
      {paymentStatus === "campaignCreated" &&  <img  src={paymentSuccess} />}
      {paymentStatus === "pending" &&  
        <div className='scale-up-center'>
          <h4>Your payment status is <span className='verifying'>being verified</span></h4>
          <p>please don’t close the website</p>
        </div>
      }
      {paymentStatus === "success" && 
        <div className='scale-up-center'>
          <h4>Payment <span className='success'>Successful</span>!</h4>
          <p>Your campaign is being reviewed</p>
        </div>
      }
      {paymentStatus === "failed" && 
        <div className='scale-up-center'>
           <h4 >Your payment has <span className='failed'>Failed</span></h4>
      <p>if any amount debited, will refund in 7 days</p>
        </div>
      }
      {paymentStatus === "campaignCreated" && 
        <div className='scale-up-center'>
           <h4>Your campaign has been <span className='campaignCreated'>Created</span></h4>
      <p>You can view your ads under campaigns tab</p>
        </div>
      }

    </div>
  )
}

export default PaymentModal